import React from 'react';

export default function SectionCard({
    title,
    right,
    children,
    className,
}: {
    title: React.ReactNode;
    right?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <div
            className={[
                'flex h-full flex-col rounded-[24px] border border-slate-200/80 bg-white/96 shadow-[0_16px_40px_-26px_rgba(15,23,42,0.26)]',
                className,
            ]
                .filter(Boolean)
                .join(' ')}
        >
            <div className="flex items-center justify-between border-b border-slate-200/80 px-5 py-4">
                <div className="text-sm font-semibold tracking-tight text-slate-900">{title}</div>
                {right}
            </div>
            <div className="p-5">{children}</div>
        </div>
    );
}
